
/**
 * Converts key, value object to to object containing keys: header and body. 
 * 
 * Header contains a string of keys, each separated with a comma, that is attached to the url
 * Body contains the post message csv data as an array of strings where each string is supposed to be a single line.
 * 
 * 
 * @param {} dataObject The object providing the data
 * @param {} keys Array of keys to be sent.
 */
export function dataObjectToCsvByKeys(dataObject = false, keys = []) {

    if(!dataObject || typeof dataObject !== "object") return false;
    
    
    const dataInArray = Array.isArray(dataObject) ? dataObject : [dataObject];
    
    if(keys.length === 0) {
        keys = Object.keys(dataInArray[0]);
    }


    const dataRows = dataInArray.map(data => {
        return keys.reduce((row, key, ind) => {


            const dataCell = cellFormatter(data[key]);
            row = row + dataCell + (ind+1 < keys.length ? "," : "");
            return row;
        }, "");
    });


    return {
        header: keys.join(","),
        body: dataRows
    };
}

/**
 * Helper function dataObjectToCsvByKeys that parses the value of a cell to the format required in the csv.
 * 
 * @param {} obj cell value
 */
export function cellFormatter(obj) {

    // null's type is object that causes a problem in the switch case
    if(obj === null) {
        return "null";
    }

    // Format the cell based on the type of the cell
    switch(typeof obj) {
        case "object":
        case "array":
            return `"${JSON.stringify(obj)}"`;
        default:
            return obj;

    }
}